/** Primary navigation, shared by the header and footer. */
export const NAV_LINKS = [
  { to: "/about", label: "About Us" },
  { to: "/services", label: "Services" },
  { to: "/divisions", label: "Divisions" },
  { to: "/our-work", label: "Our Work" },
  { to: "/quality-safety", label: "Quality & Safety" },
  { to: "/contact", label: "Contact" },
];
